export default function IconUnmute({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                fill="white"
                fillOpacity="0.2"
            />
            <path
                d="M12 23.625C18.4203 23.625 23.625 18.4203 23.625 12C23.625 5.57969 18.4203 0.375 12 0.375C5.57969 0.375 0.375 5.57969 0.375 12C0.375 18.4203 5.57969 23.625 12 23.625Z"
                stroke="white"
                strokeWidth="0.75"
            />

            <path
                d="M16.75 13L17.75 12M17.75 12L18.75 11M17.75 12L16.75 11M17.75 12L18.75 13"
                stroke="white"
                strokeWidth="0.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 12.9284V11.0714C8 10.8062 8.10536 10.5518 8.29289 10.3643C8.48043 10.1767 8.73478 10.0714 9 10.0714H10.45C10.5478 10.0714 10.6434 10.0427 10.725 9.98888L13.725 8.01088C13.8004 7.96125 13.8878 7.93293 13.9779 7.92895C14.0681 7.92497 14.1577 7.94547 14.2371 7.98828C14.3166 8.03108 14.383 8.09459 14.4293 8.17208C14.4755 8.24956 14.5 8.33813 14.5 8.42838V15.5714C14.5 15.6616 14.4755 15.7502 14.4293 15.8277C14.383 15.9052 14.3166 15.9687 14.2371 16.0115C14.1577 16.0543 14.0681 16.0748 13.9779 16.0708C13.8878 16.0668 13.8004 16.0385 13.725 15.9889L10.725 14.0109C10.6434 13.9571 10.5478 13.9284 10.45 13.9284H9C8.73478 13.9284 8.48043 13.823 8.29289 13.6355C8.10536 13.4479 8 13.1936 8 12.9284Z"
                stroke="white"
                strokeWidth="0.75"
            />
        </svg>
    )
}
